// extracted by mini-css-extract-plugin
export var label = "_df-1";
export var reminder = "_df-0";